export default __webpack_public_path__ + "static/30-yard-dumpster-icon-d8ed9017bdffe9119a7119c312103b12.png";